import { useEffect, useMemo, useState } from 'react';
import Page from '../../containers/page';
import { Tabs } from '../../form-v2/form.component';
import LabPortalenComponent from '../patients/components/labportalen';
import useFetchData from '../../hooks/fetch-data.hook';
// import PatientDocumentInfoTextTooltip from '../../components/patientDocumentInfoTextTooltip';
import LabPortalenRemissTemplates from '../patients/components/labportalen-remiss-templates';

const _tabs = {
    'inbox': {
        label: 'Inbox',
        _title: 'Group labs - Inbox',
    },
    'outbox': {
        label: 'Outbox',
        _title: 'Group labs - Outbox',
    }
}

const LabsPage = (props) => {
    const [tabs, setTabs] = useState(_tabs)
    const [tab, setTab] = useState('inbox');
    const selectedGroup = props?.selectedGroup;
    const selectedClinic = props?.selectedClinic;
    const { data } = useFetchData(selectedGroup ? `/data/clinic-group-settings/${selectedGroup}` : null);

    const departmentId = useMemo(() => {
        if (data?.clinicGroupSettings?.labPortalen?.departments && selectedClinic) {
            const department = data.clinicGroupSettings.labPortalen.departments.find?.(obj => obj && obj._id && obj._id === selectedClinic);
            if (department && department.labPortalenId) {
                return department.labPortalenId;
            }
        };

        return undefined;
    }, [data, selectedClinic, selectedGroup]);

    useEffect(() => {
        if (data?.clinicGroupSettings?.labPortalen?.hasRemiss) {
            setTabs({
                ..._tabs,
                'remiss': {
                    label: 'e-Remiss Templates',
                    _title: 'LabPortalen e-Remiss Templates',
                }
            })
        } else {
            setTabs(_tabs);
        }
    }, [data])

    return (
        <div className={props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>
            <Tabs
                tabs={tabs}
                tab={tab}
                lang={props?.lang || 'se'}
                onChange={setTab}
            // sideComponent={<PatientDocumentInfoTextTooltip
            //     lang={props.lang}
            //     text='Curoflow has no control over data in LabPortalen. Please double check the data before sharing with patients.'
            // />}
            />
            {tab !== 'remiss' ? <LabPortalenComponent
                key={tab}
                type={tab}
                sessionCode={props.uData?.labPortalenSessionCode}
                dashboardUrl={props.uData?.labPortalenDashboardUrl}
                departmentId={departmentId}
                lang={props.lang}
                title={tabs[tab]?._title || ''}
            /> : <LabPortalenRemissTemplates
                key={tab}
                {...props}
                departmentId={departmentId}
            />}
        </div>
    )
}

export default Page(LabsPage)